import React, { useEffect, useRef, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SpecialsPage from "./components/SpecialsPage";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./components/HomePage";

import NotFoundPage from "./components/NotFoundPage";
import Furniture from "./components/Furniture";
import AboutUs from "./components/AbousUs";
import BlogList from "./components/BlogList";
import faussetImage from "./assets/fausset.jpg";
import faussetImage2 from "./assets/fausset2.jpg";
import faussetImage3 from "./assets/fausset3.jpeg";
import faussetImage4 from "./assets/fausset4.jpg";
import Article from "./components/Article";
import Departments from "./components/Departments";
import SubDepartments from "./components/SubDepartments";
import MapComponent from "./components/MapComponent";
import ErrorBoundary from "./components/ErrorBoundary";
import ContactInfo from "./components/ContactInfo";
import CTAWithLocation from "./components/hooks/CTAWithLocation";
import SubdepartmentArticles from "./components/SubdepartmentArticles";
import Carousel from "./components/Carousel";
import { useI18nField } from "./locale/LocaleContext"; // <-- for translations
import AdminPage from "./components/admin/AdminPage"; 
import { useRouteMeta } from "./components/hooks/useRouteMeta";
// For bootstrap
import "@/bootstrap-custom.scss";
// For mobile menu styles
import "@/components/CSS/MobileMenu.scss";

// Small hook to translate inline strings using your existing i18n field helper
function useTr() {
  const f = useI18nField();
  // Reuse `useI18nField` by passing a tiny object with {en, fr} and reading "name"
  return (en, fr) => f({ name: { en, fr } }, "name");
}

/** Route element wrappers so we can use hooks (useLocation/useTr) cleanly */
function BlogRoute() {
  const tr = useTr();
  const location = useLocation();

  // ✅ Load SEO for blog/news page
  useRouteMeta("News", {
    metaTitle: {
      en: "News | My Company",
      fr: "Actualités | Mon entreprise",
    },
    metaDescription: {
      en: "Read our latest company news, updates, and insights.",
      fr: "Lisez nos dernières nouvelles, mises à jour et informations.",
    },
    metaOgTitle: {
      en: "Latest News",
      fr: "Dernières actualités",
    },
    metaOgDescription: {
      en: "Stay informed with our most recent updates and blog posts.",
      fr: "Restez informé grâce à nos mises à jour récentes et articles.",
    },
    metaOgImage: "https://example.com/og-news.jpg",
  });

  return (
    <>
      <BlogList collectionName="news" />
      <CTAWithLocation
        headingText={tr(
          "Discover our bespoke solutions for your business.",
          "Découvrez nos solutions sur mesure pour votre entreprise."
        )}
        buttonText={tr("Contact Us", "Contactez-nous")}
        currentPath={location.pathname}
      />
    </>
  );
}



function ServicesRoute() {
  const tr = useTr();
  const location = useLocation();

  // 🔥 Insert this hook right here
  useRouteMeta("Services", {
    metaTitle: {
      en: "Our Services | My Company",
      fr: "Nos services | Mon entreprise",
    },
    metaDescription: {
      en: "Explore the range of services we provide.",
      fr: "Découvrez la gamme de services que nous offrons.",
    },
    metaOgTitle: {
      en: "Services | My Company",
      fr: "Services | Mon entreprise",
    },
    metaOgDescription: {
      en: "Professional services designed to help you grow.",
      fr: "Des services professionnels conçus pour vous aider à croître.",
    },
    metaOgImage: "https://example.com/og-services.jpg",
  });

  return (
    <>
      <BlogList collectionName="services" />
      <CTAWithLocation
        headingText={tr(
          "Discover our bespoke solutions for your business.",
          "Découvrez nos solutions sur mesure pour votre entreprise."
        )}
        buttonText={tr("Contact Us", "Contactez-nous")}
        currentPath={location.pathname}
      />
    </>
  );
}


function ContactRoute() {
  const tr = useTr();
  const location = useLocation();

  // ✅ Load SEO meta tags for this page
  useRouteMeta("Contact", {
    metaTitle: {
      en: "Contact Us | My Company",
      fr: "Contactez-nous | Mon entreprise",
    },
    metaDescription: {
      en: "Get in touch with our team — phone, email, or contact form.",
      fr: "Contactez notre équipe — téléphone, courriel ou formulaire.",
    },
    metaOgTitle: {
      en: "Contact Us",
      fr: "Contactez-nous",
    },
    metaOgDescription: {
      en: "Reach our support and sales teams quickly and easily.",
      fr: "Communiquez rapidement et facilement avec nos équipes.",
    },
    metaOgImage: "https://example.com/og-contact.jpg",
  });

  return (
    <ErrorBoundary>
      <MapComponent />
      <ContactInfo />
      <CTAWithLocation
        headingText={tr("Quick link to reach us", "Lien rapide pour nous joindre")}
        buttonText={tr("Send Message", "Envoyer un message")}
        currentPath={location.pathname}
      />
    </ErrorBoundary>
  );
}

function App() {
  const specialsData = [
    {
      title: "Article one",
      imageUrl: [faussetImage, faussetImage3],
      description: "Detailed description of Article one.",
      url: "link-to-article-1",
    },
    {
      title: "Article two",
      imageUrl: [faussetImage2, faussetImage3, faussetImage4],
      description:
        "Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.",
      url: "link-to-article-2",
    },
    {
      title: "Article one",
      imageUrl: [faussetImage3, faussetImage4],
      description: "Detailed description of Article one.",
      url: "link-to-article-1",
    },
    {
      title: "Article two",
      imageUrl: [faussetImage4, faussetImage3],
      description: "Detailed description of Article two.",
      url: "link-to-article-2",
    },
    {
      title: "Article one",
      imageUrl: [faussetImage, faussetImage3],
      description: "Detailed description of Article one.",
      url: "link-to-article-1",
    },
    {
      title: "Article two",
      imageUrl: [faussetImage2, faussetImage3, faussetImage4],
      description:
        "Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.Detailed description of Article two.",
      url: "link-to-article-2",
    },
    {
      title: "Article one",
      imageUrl: [faussetImage3, faussetImage4],
      description: "Detailed description of Article one.",
      url: "link-to-article-1",
    },
    {
      title: "Article two",
      imageUrl: [faussetImage4, faussetImage3],
      description: "Detailed description of Article two.",
      url: "link-to-article-2",
    },
  ];

  const [isSticky, setIsSticky] = useState(false); // Track header sticky state
  const [activeSection, setActiveSection] = useState(""); // Active section identifier

  const sectionsRef = useRef({
    hero: useRef(null),
    Specials: useRef(null),
    cta: useRef(null),
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
            setActiveSection(entry.target.id); // Set active section
          }
        });
        // Update sticky state based on whether the Hero section is in view
        setIsSticky(!entries[0].isIntersecting);
      },
      {
        rootMargin: "-100px 0px 0px 0px",
        threshold: 0.3,
      }
    );

    // Observe each section
    Object.values(sectionsRef.current).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      Object.values(sectionsRef.current).forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header isSticky={isSticky} activeSection={activeSection} />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />

          {/* <Route
            path="/specials"
            element={
              <>
                <Hero />
                <Article
                  data={specialsData}
                  title="Special Articles"
                  style={{ backgroundColor: "#f0f0f0" }}
                />
              </>
            }
          /> */}
          <Route path="/specials" element={<SpecialsPage />} />

          <Route
            path="/furniture"
            element={
              <>
                <Hero />
                <Furniture />
                <CTASection />
              </>
            }
          />

          <Route
            path="/about-us"
            element={
              <>
                <AboutUs />
              </>
            }
          />

          {/* Blog and Services now wrapped so we can translate CTA strings */}
          <Route path="/blog" element={<BlogRoute />} />
          <Route path="/services" element={<ServicesRoute />} />

          <Route path="/departments" element={<Departments />} />
          <Route path="/departments/:deptId" element={<SubDepartments />} />
          <Route
            path="/departments/:deptId/subdepartments/:subdeptId/articles"
            element={<SubdepartmentArticles />}
          />

          {/* Contact route wrapped for translated CTA */}
          <Route path="/contact" element={<ContactRoute />} />

          <Route path="*" element={<NotFoundPage />} />
          <Route path="/_admin" element={<AdminPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
